import React, { useContext } from 'react';

import { ApiContext } from '_lib/api/apiContext';
import { TimezoneAbbreviationEnum } from '_lib/api/apiTypes.shim';
import { BackdropSpinner } from '_lib/components/BackdropSpinner/BackdropSpinner';
import { FlexBox } from '_lib/components/FlexBox/FlexBox';
import { ManualErrorBoundary } from '_lib/components/ManualErrorBoundary/ManualErrorBoundary';
import { AiCallDisplay } from '_lib/featureComponents/AiCall/AiCallDisplay';

type PhoneCallAiCallProps = {
  aiCallId: string;
  gridItemSize: number;
  timezone: TimezoneAbbreviationEnum;
};

export const PhoneCallAiCall = (props: PhoneCallAiCallProps) => {
  const { aiCallId, timezone, gridItemSize } = props;

  const api = useContext(ApiContext);

  const aiCallQuery = api.aiCalls.useGetById({ id: aiCallId });

  const aiVoicesQuery = api.appConfig.useAiVoiceConfigQuery();

  if (aiCallQuery.error || aiVoicesQuery.error) {
    return (
      <ManualErrorBoundary
        errorState={{ error: aiCallQuery.error || aiVoicesQuery.error, message: 'Error fetching CPI Call' }}
        reportingCtx={{ extra: { aiCallId } }}
        onRefresh={async () => {
          aiCallQuery.refetch();
          aiVoicesQuery.refetch();
        }}
      />
    );
  }

  if (aiCallQuery.isFetching || aiVoicesQuery.isFetching)
    return (
      <FlexBox sx={{ position: 'relative', minHeight: '150px' }}>
        <BackdropSpinner open />
      </FlexBox>
    );

  if (!aiCallQuery.data) return <ManualErrorBoundary errorState={{ message: 'CPI Call not found.' }} />;

  const aiVoice = aiVoicesQuery.data?.results?.find((voice) => voice.id === aiCallQuery.data.providerCall.aiVoiceId);

  return <AiCallDisplay aiCall={aiCallQuery.data} aiVoice={aiVoice} gridItemSize={gridItemSize} timezone={timezone} />;
};
